<template>
	<button
		class="text-grey-600 bg-grey-100 hover:bg-grey-200 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
	>
		<slot />
	</button>
</template>
